/**
 * Этот файл — каталог компонентов
 * для единого управления экспортируемыми компонентами
 */
/**
 * Компоненты макета
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import ThemeToggle from './ThemeToggle';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  ThemeToggle,
};
